/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Constants, Seconds } from '@wit/vtv-x-foundation-lib';
import VisualScrubberUtilsCore from 'core/services/utils/VisualScrubberUtils';

interface Indexes {
  spriteIndex: number;
  thumbnailIndex: number;
}

export default class VisualScrubberUtils extends VisualScrubberUtilsCore {
  private static THUMBNAIL_INTERVAL: Seconds = Constants.SECONDS_PER_SPRITE / Constants.NUMBER_THUMBNAILS_PER_SPRITE;

  static getThumbnailInterval(): number {
    return this.THUMBNAIL_INTERVAL;
  }

  static getPositionsFromProgress(progress: Seconds): Indexes {
    const spriteIndex = Math.floor(progress / Constants.SECONDS_PER_SPRITE);

    return {
      spriteIndex,
      thumbnailIndex:
        Math.floor(progress / this.THUMBNAIL_INTERVAL) - Constants.NUMBER_THUMBNAILS_PER_SPRITE * spriteIndex,
    };
  }

  static getProgressAdjustmentForLivePosition(thumbnailIndex: number): Seconds {
    return this.getThumbnailInterval() * (thumbnailIndex + 1);
  }

  static getSpriteThreshold(spriteIndex: number, inLiveSprite?: boolean): Seconds {
    return Constants.SECONDS_PER_SPRITE * (spriteIndex + (!inLiveSprite ? 1 : 0));
  }
}
